export const baseApiUrl = 'https://m.tripeasy.com/v62/api';
export const siteUrl = 'www.tripeasy.com';
export const cdnUrl = 'https://cdn2.its.com/Content/';
export const ssoUrl = 'https://tripeasy.com/Home/ssomsite/';
export const newApiUrl = 'https://lnoc7lcxxb.execute-api.us-east-1.amazonaws.com/prod';
export const androidSSO = 'itsmobile:///login/sso/';
export const weatherServiceUrl = 'https://www.weatherbug.com/weather-forecast/now/';
export const openTablesServiceUrl = 'https://www.opentable.com/s?term=';

export const contactAgentEMail = 'support@tripeasy.com';
export const contactAgentTel = '855-301-8472';
export const GOOGLE_PACKAGE_NAME = 'com.TripEasyCorpTravel';
export const APPLE_STORE_ID = 'id284882215';
export const GOOGLE_KEY = 'AIzaSyBC7CANiEb5GV41_o0pUbeRByiZALw1pZo';
export const TRIPHUB_ENABLED = false;
export const REBOOK_ENABLED = false;
export const AA_ENABLED = false;
export const TRIPEVENTS_ENABLED = false;
export const EVENTS_ENABLED = false;
export const EXPENSEPOINT_ENABLED = false;
export const expenseReceiptEmail = 'receipts@tripeasy.com';
